// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/party.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { FilterGroup, PageRequest, PageResponse, SortSpec } from "./common_pb.js";

/**
 * @generated from enum omnios.v1.PartyKind
 */
export const PartyKind = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.PartyKind",
  [
    {no: 0, name: "PARTY_KIND_UNSPECIFIED"},
    {no: 1, name: "PERSON"},
    {no: 2, name: "ORGANIZATION"},
    {no: 3, name: "TEAM"},
    {no: 4, name: "AGENT"},
  ],
);

/**
 * @generated from enum omnios.v1.AgentRunMode
 */
export const AgentRunMode = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.AgentRunMode",
  [
    {no: 0, name: "AGENT_RUN_MODE_UNSPECIFIED"},
    {no: 1, name: "AUTONOMOUS"},
    {no: 2, name: "SUPERVISED"},
    {no: 3, name: "ON_DEMAND"},
  ],
);

/**
 * @generated from enum omnios.v1.ChannelKind
 */
export const ChannelKind = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.ChannelKind",
  [
    {no: 0, name: "CHANNEL_KIND_UNSPECIFIED"},
    {no: 1, name: "WHATSAPP"},
    {no: 2, name: "TELEGRAM"},
    {no: 3, name: "EMAIL"},
    {no: 4, name: "SMS"},
    {no: 5, name: "PHONE"},
  ],
);

/**
 * @generated from enum omnios.v1.ChannelScope
 */
export const ChannelScope = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.ChannelScope",
  [
    {no: 0, name: "CHANNEL_SCOPE_UNSPECIFIED"},
    {no: 1, name: "CORPORATE"},
    {no: 2, name: "PERSONAL"},
  ],
);

/**
 * Unified entity: people, companies, teams
 * Replaces Customer + Contact + ContactRecord + User + Branch
 *
 * @generated from message omnios.v1.Party
 */
export const Party = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Party",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kind", kind: "enum", T: proto3.getEnumType(PartyKind) },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "attrs", kind: "message", T: Struct },
    { no: 7, name: "is_internal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
    { no: 12, name: "deleted_at", kind: "message", T: Timestamp },
    { no: 20, name: "channels", kind: "message", T: Channel, repeated: true },
    { no: 21, name: "relationships", kind: "message", T: PartyRelationship, repeated: true },
    { no: 22, name: "agent_config", kind: "message", T: AgentConfig },
    { no: 25, name: "roles", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 30, name: "pricing_tier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "contract_pricing", kind: "message", T: Struct },
    { no: 32, name: "volume_tiers", kind: "message", T: Struct },
    { no: 33, name: "payment_terms_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 34, name: "sales_rep_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 35, name: "relationship_score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 36, name: "zitadel_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Agent-specific configuration (stored in party.attrs, surfaced here for convenience)
 *
 * @generated from message omnios.v1.AgentConfig
 */
export const AgentConfig = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AgentConfig",
  () => [
    { no: 1, name: "model", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "system_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tools", kind: "message", T: AgentTool, repeated: true },
    { no: 4, name: "run_mode", kind: "enum", T: proto3.getEnumType(AgentRunMode) },
    { no: 5, name: "settings", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.AgentTool
 */
export const AgentTool = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AgentTool",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "parameters_schema", kind: "message", T: Struct },
  ],
);

/**
 * Communication endpoint belonging to a party
 *
 * @generated from message omnios.v1.Channel
 */
export const Channel = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Channel",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "kind", kind: "enum", T: proto3.getEnumType(ChannelKind) },
    { no: 5, name: "scope", kind: "enum", T: proto3.getEnumType(ChannelScope) },
    { no: 6, name: "identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "settings", kind: "message", T: Struct },
    { no: 8, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * Relationship between two parties
 *
 * @generated from message omnios.v1.PartyRelationship
 */
export const PartyRelationship = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PartyRelationship",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "from_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "to_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "attrs", kind: "message", T: Struct },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreatePartyRequest
 */
export const CreatePartyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePartyRequest",
  () => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(PartyKind) },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "attrs", kind: "message", T: Struct },
    { no: 5, name: "is_internal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "agent_config", kind: "message", T: AgentConfig },
  ],
);

/**
 * @generated from message omnios.v1.GetPartyRequest
 */
export const GetPartyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPartyRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePartyRequest
 */
export const UpdatePartyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePartyRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "attrs", kind: "message", T: Struct },
    { no: 10, name: "pricing_tier", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 11, name: "contract_pricing", kind: "message", T: Struct },
    { no: 12, name: "volume_tiers", kind: "message", T: Struct },
    { no: 13, name: "payment_terms_days", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 14, name: "sales_rep_user_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeletePartyRequest
 */
export const DeletePartyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeletePartyRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPartiesRequest
 */
export const ListPartiesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPartiesRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "filter", kind: "message", T: FilterGroup },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
    { no: 4, name: "kind", kind: "enum", T: proto3.getEnumType(PartyKind), opt: true },
    { no: 5, name: "is_internal", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ListPartiesResponse
 */
export const ListPartiesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPartiesResponse",
  () => [
    { no: 1, name: "parties", kind: "message", T: Party, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.CreateChannelRequest
 */
export const CreateChannelRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateChannelRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "kind", kind: "enum", T: proto3.getEnumType(ChannelKind) },
    { no: 3, name: "scope", kind: "enum", T: proto3.getEnumType(ChannelScope) },
    { no: 4, name: "identifier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "settings", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.LinkPartiesRequest
 */
export const LinkPartiesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.LinkPartiesRequest",
  () => [
    { no: 1, name: "from_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "to_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.UnlinkPartiesRequest
 */
export const UnlinkPartiesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UnlinkPartiesRequest",
  () => [
    { no: 1, name: "relationship_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Custom field definition for Party CRM
 *
 * @generated from message omnios.v1.PartyFieldDefinition
 */
export const PartyFieldDefinition = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PartyFieldDefinition",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "field_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "options", kind: "message", T: Struct },
    { no: 7, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "applies_to", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreateFieldDefinitionRequest
 */
export const CreateFieldDefinitionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateFieldDefinitionRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "field_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "options", kind: "message", T: Struct },
    { no: 5, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "applies_to", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdateFieldDefinitionRequest
 */
export const UpdateFieldDefinitionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateFieldDefinitionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "options", kind: "message", T: Struct },
    { no: 4, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 5, name: "is_required", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 6, name: "applies_to", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteFieldDefinitionRequest
 */
export const DeleteFieldDefinitionRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteFieldDefinitionRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListFieldDefinitionsRequest
 */
export const ListFieldDefinitionsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListFieldDefinitionsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
  ],
);

/**
 * @generated from message omnios.v1.ListFieldDefinitionsResponse
 */
export const ListFieldDefinitionsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListFieldDefinitionsResponse",
  () => [
    { no: 1, name: "field_definitions", kind: "message", T: PartyFieldDefinition, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.PartySupplierFeed
 */
export const PartySupplierFeed = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PartySupplierFeed",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "feed_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "feed_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "feed_config", kind: "message", T: Struct },
    { no: 7, name: "last_import_at", kind: "message", T: Timestamp },
    { no: 8, name: "last_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "last_work_item_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "item_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "created_at", kind: "message", T: Timestamp },
    { no: 12, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListPartySupplierFeedsRequest
 */
export const ListPartySupplierFeedsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPartySupplierFeedsRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPartySupplierFeedsResponse
 */
export const ListPartySupplierFeedsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPartySupplierFeedsResponse",
  () => [
    { no: 1, name: "feeds", kind: "message", T: PartySupplierFeed, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreatePartySupplierFeedRequest
 */
export const CreatePartySupplierFeedRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePartySupplierFeedRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "feed_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "feed_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "feed_config", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePartySupplierFeedRequest
 */
export const UpdatePartySupplierFeedRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePartySupplierFeedRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "feed_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "feed_type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "feed_config", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.DeletePartySupplierFeedRequest
 */
export const DeletePartySupplierFeedRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeletePartySupplierFeedRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AddPartyCommentRequest
 */
export const AddPartyCommentRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddPartyCommentRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PartyPreferences
 */
export const PartyPreferences = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PartyPreferences",
  () => [
    { no: 1, name: "default_markup", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "category_rules", kind: "message", T: CategoryRule, repeated: true },
    { no: 3, name: "brand_include", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "brand_exclude", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "price_min", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "price_max", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "logistics_notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "free_text_rules", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "default_export_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "seasonal_rules", kind: "message", T: SeasonalRule, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CategoryRule
 */
export const CategoryRule = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CategoryRule",
  () => [
    { no: 1, name: "category_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "category_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "markup", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "included", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * A named seasonal selection (e.g. "8 марта", "Новый год"). The window
 * is informational; markup overrides default_markup during the window;
 * category_ids/brand_ids narrow what's included if non-empty.
 *
 * @generated from message omnios.v1.SeasonalRule
 */
export const SeasonalRule = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SeasonalRule",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "start_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "end_date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "category_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "brand_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "markup", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPartyPreferencesRequest
 */
export const GetPartyPreferencesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPartyPreferencesRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePartyPreferencesRequest
 */
export const UpdatePartyPreferencesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePartyPreferencesRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "preferences", kind: "message", T: PartyPreferences },
  ],
);

/**
 * @generated from message omnios.v1.BulkDeletePartiesRequest
 */
export const BulkDeletePartiesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkDeletePartiesRequest",
  () => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "all", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.BulkDeletePartiesResponse
 */
export const BulkDeletePartiesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.BulkDeletePartiesResponse",
  () => [
    { no: 1, name: "deleted", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.AddPartyRoleRequest
 */
export const AddPartyRoleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AddPartyRoleRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RemovePartyRoleRequest
 */
export const RemovePartyRoleRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RemovePartyRoleRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetCustomerOrderStatsRequest
 */
export const GetCustomerOrderStatsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetCustomerOrderStatsRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.CustomerOrderStats
 */
export const CustomerOrderStats = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CustomerOrderStats",
  () => [
    { no: 1, name: "total_orders", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "total_spent_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "avg_order_value_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "last_order_at", kind: "message", T: Timestamp },
    { no: 5, name: "credit_limit_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ],
);

/**
 * @generated from message omnios.v1.PartyProduct
 */
export const PartyProduct = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PartyProduct",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "custom_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 5, name: "custom_currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "is_available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "product_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "product_vendor_codes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "product_category_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "default_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 14, name: "default_price_currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PartyProductEntry
 */
export const PartyProductEntry = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PartyProductEntry",
  () => [
    { no: 1, name: "product_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "custom_price_cents", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 3, name: "custom_currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "is_available", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SetPartyProductsRequest
 */
export const SetPartyProductsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SetPartyProductsRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "entries", kind: "message", T: PartyProductEntry, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.RemovePartyProductsRequest
 */
export const RemovePartyProductsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RemovePartyProductsRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "product_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.ListPartyProductsRequest
 */
export const ListPartyProductsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPartyProductsRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "message", T: PageRequest },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPartyProductsResponse
 */
export const ListPartyProductsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPartyProductsResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: PartyProduct, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
    { no: 3, name: "total_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SendClientInviteRequest
 */
export const SendClientInviteRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SendClientInviteRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "portal_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SendClientInviteResponse
 */
export const SendClientInviteResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SendClientInviteResponse",
  () => [
    { no: 1, name: "invite_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListClientInvitesRequest
 */
export const ListClientInvitesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListClientInvitesRequest",
  () => [
    { no: 1, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ClientInvite
 */
export const ClientInvite = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ClientInvite",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "redirect_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
    { no: 6, name: "expires_at", kind: "message", T: Timestamp },
    { no: 7, name: "claimed_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListClientInvitesResponse
 */
export const ListClientInvitesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListClientInvitesResponse",
  () => [
    { no: 1, name: "invites", kind: "message", T: ClientInvite, repeated: true },
  ],
);

